import { OtpViewController } from './OtpViewController';
import { diContainer, getParamsForOtpViewController } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { OtpType, OTP_TYPE_EMAIL } from '~constants/Constants';

export const OtpViewControllerFactory = {
    create(otpType?: OtpType): OtpViewController {
        // Get otp type from route parameter if no parameter
        const type = otpType || diContainer.get(serviceNames.userRepository).otpStore.data?.type;

        return diContainer.get(
            type === OTP_TYPE_EMAIL
                ? serviceNames.otpEmailViewController
                : serviceNames.otpSmsViewController
        );
    },
    mock(): OtpViewController {
        class MockOtpViewController extends OtpViewController {
            get miscellaneous() {
                return {
                    sendTo: '',
                    changeTo: '',
                    switchTo: ''
                };
            }

            get requestBase() {
                return { emailAddress: '' };
            }

            get switchToOtpType(): OtpType {
                return 'sms';
            }
            saveRequestIdIntoUserStore(id: string): void {}
        }

        return new MockOtpViewController(getParamsForOtpViewController(diContainer));
    }
};
